document.addEventListener('DOMContentLoaded', function () {
    var calendarEl = document.getElementById('calendar');
function mobileCheck() {
        if (window.innerWidth >= 768 ) {
            return false;
        } else {
            return true;
        }
    };
    var calendar = new FullCalendar.Calendar(calendarEl, {
      timeZone: 'UTC',
      themeSystem: 'bootstrap5',
      headerToolbar: {
        left: mobileCheck() ? "prev" : 'prev,next today',
        center: mobileCheck() ? "title" :'title',
        right: mobileCheck() ? "next" : ''
      },
      weekNumbers: true,
       firstDay: 1,
      initialView: mobileCheck() ? "listMonth" : "dayGridMonth",
      defaultAllDay: true,
      dayMaxEvents: false, // allow "more" link when too many events
      events: 'https://bhaktimarga.org/up/bmdatahub/country/eventhubforcalendar.php?code=bhaktimarga-india'
    });

    calendar.render();
  });